import { defineComponent, computed } from 'vue';
import { imageSizes, generateSrcString } from 'src/plugins/images/generateSrcString';
import { checkUrlObjAndReturnUrl } from 'src/plugins/images/general';
import { convertUrlToWebp } from 'src/plugins/images/general';
import picSet from './picSet.vue';
export default defineComponent({
    name: 'standardAvatar',
    props: {
        pic: {
            type: [String, Object]
        },
        allowOtherFormats: Boolean,
        format: String,
        showLoad: Boolean,
        size: {
            type: String
        },
        alternate: {
            type: String,
            default: 'https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_512.png'
        },
        alternativeSrcSet: {
            type: String,
            default: `
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_16.png 16w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_32.png 32w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_48.png 48w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_72.png 72w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_128.png 128w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_144.png 144w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_256.png 256w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_512.png 512w
      `
        },
        alternativeWebpSrcSet: {
            type: String,
            default: `
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_16.webp 16w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_32.webp 32w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_48.webp 48w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_72.webp 72w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_128.webp 128w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_144.webp 144w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_256.webp 256w,
        https://dminqct125wnz.cloudfront.net/common/default/profile/profile_default_512.webp 512w
      `
        },
        defaultAlt: {
            type: String,
            default: 'Profile Picture'
        },
        avatarClass: {
            type: Object,
            default: () => {
                return {};
            }
        },
        picClass: {
            type: Object,
            default: () => {
                return {};
            }
        },
        sizeType: String,
        originalSize: String,
        componentSize: String
    },
    emits: ['click'],
    components: {
        picSet
    },
    setup(props) {
        // get pic url by combining url and format string
        const picImg = computed(() => {
            return checkUrlObjAndReturnUrl(props.pic, props.format);
        });
        const srcSets = computed(() => {
            // return base url sets according to sizes
            if (props.sizeType &&
                props.originalSize &&
                props.sizeType &&
                imageSizes[props.sizeType]) {
                const setStrings = generateSrcString({
                    url: picImg.value,
                    originalSize: props.originalSize,
                    sizeType: props.sizeType
                });
                return setStrings;
            }
            // return url sets with webp
            if (props.allowOtherFormats) {
                return {
                    original: '',
                    webp: convertUrlToWebp(picImg.value)
                };
            }
            return {
                original: '',
                webp: ''
            };
        });
        return { picImg, srcSets };
    }
});
